import i18n from 'modules/core/lib/i18n'

class FieldTranslations {
  t(field: string): string {
    switch (field) {
      case 'bank_number':
        return i18n.t('bookkeepers.incidence.details.bank_number')
      case 'first_name':
        return i18n.t('bookkeepers.incidence.details.first_name')
      case 'last_name':
        return i18n.t('bookkeepers.incidence.details.last_name')
      case 'identifier':
        return i18n.t('bookkeepers.incidence.details.identifier')
      case 'identifier_type':
        return i18n.t('bookkeepers.incidence.details.identifier_type')
      case 'nationality':
        return i18n.t('bookkeepers.incidence.details.nationality')
      case 'social_security_number':
        return i18n.t('bookkeepers.incidence.details.social_security_number')
      case 'gender':
      case 'sex':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.gender')
      case 'job_title':
      case 'occupational_title':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.job_title')
      case 'email':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.email')
      case 'starts_on':
      case 'date_of_commencement_of_employment':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.starts_on')
      case 'postal_code':
      case 'address_postal_code':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.postal_code')
      case 'address_line_1':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.address_line_1')
      case 'birthday_on':
      case 'date_of_birth':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.birthday_on')
      case 'phone_number':
      case 'mobile_phone_number':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.phone_number')
      case 'company_code':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.company_code')
      case 'employee_identifier':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.employee_code')
      case 'absence_code':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.absence_code')
      case 'location_code':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.location_code')
      case 'tax_id':
        return i18n.t('payroll_integrations.incidences.datev_api.unavailable_fields.tax_id')
      case 'missing_salary_code':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.title'
        )
      case 'missing_legal_entity_mapping':
        return i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.missing_legal_entity_mapping'
        )
      case 'bic':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.bic')
      case 'address_city':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.address_city'
        )
      case 'address_country':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.address_country'
        )
      case 'address_house_number':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.address_house_number'
        )
      case 'address_street':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.address_street'
        )
      case 'surname':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.surname')
      case 'place_of_birth':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.place_of_birth'
        )
      case 'birth_name':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.birth_name')
      case 'country_of_birth':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.country_of_birth'
        )
      case 'iban':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.iban')
      case 'date_of_termination_of_employment':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.date_of_termination_of_employment'
        )
      case 'employment_type':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.employment_type'
        )
      case 'flat_rate_tax':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.flat_rate_tax'
        )
      case 'tax_class':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.tax_class')
      case 'tax_identification_number':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.tax_identification_number'
        )
      case 'amount':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.salary_amount'
        )
      case 'salary_type_id':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.salary_type_id'
        )
      case 'frequency':
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.fields.frequency')
      case 'weekly_working_hours':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.weekly_working_hours'
        )
      case 'allocation_of_working_hours_monday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_monday'
        )
      case 'allocation_of_working_hours_tuesday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_tuesday'
        )
      case 'allocation_of_working_hours_wednesday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_wednesday'
        )
      case 'allocation_of_working_hours_thursday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_thursday'
        )
      case 'allocation_of_working_hours_friday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_friday'
        )
      case 'allocation_of_working_hours_saturday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_saturday'
        )
      case 'allocation_of_working_hours_sunday':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.allocation_of_working_hours_sunday'
        )
      case 'payment_months':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.payment_months'
        )
      case 'basic_vacation_entitlement':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.basic_vacation_entitlement'
        )
      case 'requested_annual_allowance':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.requested_annual_allowance'
        )
      case 'personnel_leasing':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.personnel_leasing'
        )
      case 'highest_level_of_professional_training':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.highest_level_of_professional_training'
        )
      case 'highest_level_of_education':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.highest_level_of_education'
        )
      case 'employee_type':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.employee_type'
        )
      case 'activity_type':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.activity_type'
        )
      case 'contractual_structure':
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.fields.contractual_structure'
        )
      default:
        return field
    }
  }
}

export default new FieldTranslations()
